import { Picture } from './picture.model';

export class PictureList extends Array<Picture> {}
